/*
 * File: /src/store/modules/team.js
 * Created Date: Friday April 26th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 26th April 2019 9:32:57 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

import teamService from 'src/services/teamServices.js';

const PAGE_SIZE = 1000;

const state = {
  team: undefined,
};

const getters = {
  getTeam: state => state.team,
  getUserById: state => id => {
    return state.team?.find(t => {
      if (+t.id === +id) {
        return t;
      }
    });
  }
};

const actions = {
  async fetchTeam({ commit }) {
    if (state.team != undefined) {
      return state.team;
    }

    const allUsers = [];
    let lastId = undefined;
    let hasMore = true;

    while (hasMore) {
      const filters = lastId ? [`id:lt:${lastId}`] : undefined;
      const response = await teamService.fetchTeam({
        filters,
        limit: PAGE_SIZE,
        sort: 'id:desc',
      });

      const users = response.data.data;
      allUsers.push(...users);

      if (users.length < PAGE_SIZE) {
        hasMore = false;
      } else {
        lastId = users[users.length - 1].id;
      }
    }

    commit('setTeam', allUsers);
    return allUsers;
  },
  unloadTeam({ commit }) {
    commit('setTeam', undefined);
  },
};

const mutations = {
  setTeam(state, team) {
    state.team = Object.assign([], team);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
